import React from "react";
import Calculator from "./calculator";

function App() {
  return (
    <div className="flex justify-center items-center h-screen">
      <Calculator />
    </div>
  );
}

export default App;
